import {useEffect } from "react";
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import AOS from "aos";
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
import retail from '../../images/Industries/Retail.png'
import it from '../../images/Industries/IT.png'
import Logistics from "../../images/Industries/Logistics.png"
import commercial from '../../images/Industries/Commercial.png'
import development from '../../images/Industries/Development.png'
import energy from '../../images/Industries/Energy.png'



function Industries_Slider() {

    const handleTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };

     useEffect(() => {
            AOS.init({ duration: 1000 });
        }, []);

    return (
        <>
            <div className="w-full bg-[#F8F6F6]">
                <div className="max-w-6xl mx-auto my-[130px] py-[80px] cursor-pointer" data-aos="fade-up">

                    <div className='my-[50px]'>
                        <h2 className="heading" data-aos="fade-up">Industries we serve</h2>
                        <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
                    </div>

                    <Swiper className="!p-[40px]"
                        modules={[Navigation, Pagination, A11y]}
                        spaceBetween={50}
                        slidesPerView={3}
                        navigation
                        // pagination={{ clickable: true }}
                        scrollbar={{ draggable: true }}
                        breakpoints={{
                            320: { slidesPerView: 1, spaceBetween: 40 },
                            480: { slidesPerView: 2, spaceBetween: 40 },
                            768: { slidesPerView: 2, spaceBetween: 40 },
                            1024: { slidesPerView: 3, spaceBetween: 40 },
                        }}
                    >

                        <SwiperSlide>
                            <Link to="/industries/it" onClick={handleTop}>
                                <div className="w-[322px] h-[200px] bg-white py-[50px] cursor-pointer duration-300 ease-in-out hover:scale-110">
                                    <img className="w-[50px] mx-auto" src={it} alt="Icon" />
                                    <h1 className=" font-noto font-bold text-[22px] mt-[20px] text-center">IT</h1>
                                </div>
                            </Link>
                        </SwiperSlide>

                        <SwiperSlide>
                            <Link to="/industries/retail" onClick={handleTop}>
                                <div className="w-[322px] h-[200px] bg-white py-[50px] cursor-pointer duration-300 ease-in-out hover:scale-110">
                                    <img className="w-[50px] mx-auto" src={retail} alt="Icon" />
                                    <h1 className="font-noto font-bold text-[22px] mt-[20px] text-center">Retail</h1>
                                </div>
                            </Link>

                        </SwiperSlide>

                        <SwiperSlide>
                            <Link to="/industries/logistics" onClick={handleTop}>
                                <div className="w-[322px] h-[200px] bg-white py-[50px] cursor-pointer duration-300 ease-in-out hover:scale-110">
                                    <img className="w-[50px] mx-auto" src={Logistics} alt="Icon" />
                                    <h1 className="font-noto font-bold text-[22px] mt-[20px] text-center">Logistics</h1>
                                </div>
                            </Link>
                        </SwiperSlide>

                        <SwiperSlide>
                            <Link to="/industries/development" onClick={handleTop}>
                                <div className="w-[322px] h-[200px] bg-white py-[50px] cursor-pointer duration-300 ease-in-out hover:scale-110">
                                    <img className="w-[50px] mx-auto" src={development} alt="Icon" />
                                    <h1 className="font-noto font-bold text-[22px] mt-[20px] text-center">Development</h1>
                                </div>
                            </Link>
                        </SwiperSlide>

                        <SwiperSlide>
                            <Link to="/industries/commerical" onClick={handleTop}>
                                <div className="w-[322px] h-[200px] bg-white py-[50px] cursor-pointer duration-300 ease-in-out hover:scale-110">
                                    <img className="w-[50px] mx-auto" src={commercial} alt="Icon" />
                                    <h1 className="font-noto font-bold text-[22px] mt-[20px] text-center">Commercial</h1>
                                </div>
                            </Link>
                        </SwiperSlide>

                        <SwiperSlide>
                            <Link to="/industries/energy" onClick={handleTop}>
                                <div className="w-[322px] h-[200px] bg-white py-[50px] cursor-pointer duration-300 ease-in-out hover:scale-110">
                                    <img className="w-[50px] mx-auto" src={energy} alt="Icon" />
                                    <h1 className="font-noto font-bold text-[22px] mt-[20px] text-center">Energy</h1>
                                </div>
                            </Link>
                        </SwiperSlide>

                    </Swiper>


                </div>
            </div>
        </>
    )
}

export default Industries_Slider;